import type { EventData } from '@/domains/chat/types/triz-events'
import { SSE_EVENT_TYPE } from '@/domains/chat/types/triz-events'

const messageLogStyle = 'color: #000; background-color: #f0f0f0; padding: 0 4px; border-radius: 4px;'

export function useMessageLog() {
    function onMessage(message: EventData) {
        if ([
            SSE_EVENT_TYPE.USER,
            SSE_EVENT_TYPE.AGENT
        ].includes(message.data.message_type)) {
            console.info(`%c${message.data.message_type}`, messageLogStyle, message)
        } else if (message.data.message_type) {
            console.info(`%c${message.data.message_type}`, messageLogStyle, message)
        }
    }

    return {
        onMessage,
    }
}
